export const safeToDecryptRegex = /^[\x20-\x7E]*$/;
export const safeToDecryptMultilineRegex = /^[\x20-\x7E\r\n]*$/;
